'use strict';

// this should be the entry point to your library
module.exports = {
  VerticalTimeline: require('./VerticalTimeline').default,
  VerticalTimelineElement: require('./VerticalTimelineElement').default
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-vertical-timeline-component/dist-modules/index.js
 ** module id = 321
 ** module chunks = 0
 **/